<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import api from "@/axios";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import AstronautJSON from '@/assets/animations/pesquisa_anim.json'
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Pesquisa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vue3Lottie
  },
  methods: {
    atualizarPesquisa(){
      console.log('atualizarPesquisa')
      this.updating = true
      this.usersData = []
      this.clientesData = []
      this.orcamentosData = []
      this.pedidosData = []

      api.get(`${getBaseUrl()}api/pesqavanc`, {
        params: {
          'q': this.textoPesquisa
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data[0])

        this.usersData = res.data[0]
        this.clientesData = res.data[1]

        // this.produtosList = res.data[0]
        // this.title = `(${this.produtosList.length}) Produtos`
        this.updating = false

      });
    }
  },
  data() {
    return {
      AstronautJSON,
      usersData: null,
      clientesData: null,
      orcamentosData: null,
      pedidosData: null,
      textoPesquisa: null,
      updating: true,
      title: "Pesquisa Avançada",
      items: [
        {
          text: "Suporte",
          href: "/",
        },
        {
          text: "Pesquisa Avançada",
          active: true,
        },
      ],
    };
  },
  mounted() {
    console.log('mounted suporte-pesquisa_0')

    console.log(this.$route.params)
    if (this.$route.params){

      let textoParam = this.$route.params['pesquisa']
      if (textoParam){
        this.textoPesquisa = textoParam
        this.atualizarPesquisa()
      }else{
        this.updating = false
      }
    }else {
      this.updating = false
    }



  }
};
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 55px; right: 420px;">
      <Vue3Lottie :animationData="AstronautJSON" :height="220" :width="220" />
    </span>

    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-9 col-lg-8">
        <div class="card">
          <b-tabs
              content-class="p-4"
              class="pt-2"
              nav-wrapper-class="nav-item"
              nav-class="justify-content-center nav-tabs-custom"
          >

            <b-tab :title="`Resultados para: `+ textoPesquisa" active>
              <div>
                <div class="row justify-content-center">
                  <div class="col-xl-8">
                    <h5>Resultados Pesquisa</h5>

                    <div class="mt-5" v-if="usersData">
                      <div class="d-flex flex-wrap">
                        <div class="me-2">
                          <h4>Usuários</h4>
                        </div>
                        <div class="ms-auto">
                          <span class="badge badge-soft-success badge-pill float-end ms-1 font-size-12">
                            {{ usersData.length }}
                          </span>
                        </div>
                      </div>
                      <hr class="mt-2" />
                      <div class="list-group list-group-flush">
                        <router-link v-for="data in usersData" :key="data.id"
                            :to="`/usuario/detalhe/${data.id}`"
                            class="list-group-item text-muted">
                          <i class="mdi mdi-circle-medium me-1"></i> #{{ data.id }}, {{ data.email }}, {{ data.tipo }} - {{ data.name }}
                        </router-link>
                      </div>
                    </div>


                    <div class="mt-5" v-if="clientesData">
                      <div class="d-flex flex-wrap">
                        <div class="me-2">
                          <h4>Clientes</h4>
                        </div>
                        <div class="ms-auto">
                          <span class="badge badge-soft-success badge-pill float-end ms-1 font-size-12">
                            {{ clientesData.length }}
                          </span>
                        </div>
                      </div>
                      <hr class="mt-2" />
                      <div class="list-group list-group-flush">
                        <router-link v-for="data in clientesData" :key="data.id"
                                     :to="`/cliente/detalhe/${data.id}`"
                                     class="list-group-item text-muted">
                          <i class="mdi mdi-circle-medium me-1"></i> #{{ data.id }}, {{ data.codigo }}, {{ data.nome }} - {{ data.cnpj }}
                        </router-link>
                      </div>
                    </div>

                    <div class="mt-5" v-if="orcamentosData">
                      <div class="d-flex flex-wrap">
                        <div class="me-2">
                          <h4>Orçamentos</h4>
                        </div>
                        <div class="ms-auto">
                          <span class="badge badge-soft-success badge-pill float-end ms-1 font-size-12">
                            {{ orcamentosData.length }}
                          </span>
                        </div>
                      </div>
                      <hr class="mt-2" />
                      <div class="list-group list-group-flush">
                        <router-link v-for="data in orcamentosData" :key="data.id"
                                     :to="`/orcamento/detalhe/${data.id}`"
                                     class="list-group-item text-muted">
                          <i class="mdi mdi-circle-medium me-1"></i> #{{ data.id }}, {{ data.codigo }}, {{ data.valor }} - {{ data.cliente }}
                        </router-link>
                      </div>
                    </div>

                    <div class="mt-5" v-if="pedidosData">
                      <div class="d-flex flex-wrap">
                        <div class="me-2">
                          <h4>Pedidos</h4>
                        </div>
                        <div class="ms-auto">
                          <span class="badge badge-soft-success badge-pill float-end ms-1 font-size-12">
                            {{ pedidosData.length }}
                          </span>
                        </div>
                      </div>
                      <hr class="mt-2" />
                      <div class="list-group list-group-flush">
                        <router-link v-for="data in pedidosData" :key="data.id"
                                     :to="`/pedido/detalhe/${data.id}`"
                                     class="list-group-item text-muted">
                          <i class="mdi mdi-circle-medium me-1"></i> #{{ data.id }}, {{ data.codigo }}, {{ data.valor }} - {{ data.cliente }}
                        </router-link>
                      </div>
                    </div>

                  </div>
                </div>


              </div>
            </b-tab>
          </b-tabs>
          <!-- Nav tabs -->
        </div>

        <div class="card">
          <div class="row ms-2 mt-3">
            <h5>Configuração de Atalhos</h5>
          </div>

          <div class="row">
            <div class="col-xl-4 col-md-4">
              <div class="">
                <div class="card-body">
                  <a href="javascript: void(0);" @click="$router.push('/')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Dashboard Vendas <span class="badge bg-info float-end font-size-14">da1</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/dashboard/atendimento')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Dashboard Atendimento <span class="badge bg-info float-end font-size-14">da2</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/dashboard/analitico')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Dashboard Analítico <span class="badge bg-info float-end font-size-14">da3</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/dashboard/supervisao')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Dashboard Supervisão<span class="badge bg-info float-end font-size-14">da4</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/orcamentos/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Orçamentos<span class="badge bg-info float-end font-size-14">orc</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/orcamento/editar/0')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Novo Orçamento<span class="badge bg-info float-end font-size-14">orn</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/pedidos/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Pedidos<span class="badge bg-info float-end font-size-14">ped</span></a>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-md-4">
              <div class="">
                <div class="card-body">
                  <a href="javascript: void(0);" @click="$router.push('/clientes/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Clientes<span class="badge bg-info float-end font-size-14">cli</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/cliente/editar/0')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Novo Cliente<span class="badge bg-info float-end font-size-14">cln</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/visitas/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Visitas<span class="badge bg-info float-end font-size-14">vis</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/loja/produtos')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Loja B2B<span class="badge bg-info float-end font-size-14">loj</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/calendario')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Calendário<span class="badge bg-info float-end font-size-14">cal</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/produtos/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Produtos<span class="badge bg-info float-end font-size-14">pro</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/produto/editar/0')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Novo Produto<span class="badge bg-info float-end font-size-14">prn</span></a>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-md-4">
              <div class="">
                <div class="card-body">
                  <a href="javascript: void(0);" @click="$router.push('/movcompras/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Compras<span class="badge bg-info float-end font-size-14">com</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/movcompras/monitora')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Monitoramento<span class="badge bg-info float-end font-size-14">mon</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/condicoes/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Condições de Pagamento<span class="badge bg-info float-end font-size-14">con</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/formas/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Formas de Pagamento<span class="badge bg-info float-end font-size-14">for</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/tiposopera/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Tipos de Operação<span class="badge bg-info float-end font-size-14">tpo</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/repres/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Representantes<span class="badge bg-info float-end font-size-14">rep</span></a>
                  <a href="javascript: void(0);" @click="$router.push('/financeiros/list')" class="px-3 py-2 rounded bg-light bg-opacity-50 d-block mb-2">Financeiro<span class="badge bg-info float-end font-size-14">fin</span></a>
                </div>
              </div>
            </div>



          </div>


        </div>


      </div>


      <div class="col-xl-3 col-lg-4">
        <div class="card">
          <div class="card-body p-4">

            <div class="search-box">
              <p class="text-muted">Nova pesquisa</p>
              <div class="position-relative">
                <input
                    id="inputPesquisa"
                    v-model="textoPesquisa"
                    @change="atualizarPesquisa"
                    type="text"
                    class="form-control rounded bg-light border-light"
                    placeholder="Pesquisar..."
                />
                <i class="mdi mdi-magnify search-icon"></i>
              </div>
            </div>

            <hr class="my-4" />


            <div>
              <p class="text-muted">Categorias</p>

              <ul class="list-unstyled fw-medium">
                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Orçamentos</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Pedidos
                    <span
                        class="badge badge-soft-success badge-pill float-end ms-1 font-size-12"
                    >04</span
                    ></a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Clientes</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Usuários</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Lançamentos Financeiros<span
                      class="badge badge-soft-success badge-pill ms-1 float-end font-size-12"
                  >12</span
                  ></a
                  >
                </li>
              </ul>
            </div>

            <hr class="my-4" />
            <div>
              <p class="text-muted">Total Registros</p>

              <ul class="list-unstyled fw-medium">

                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Orçamentos
                    <span
                        class="badge badge-soft-success badge-pill float-end ms-1 font-size-12"
                    >422</span
                    ></a
                  >
                </li>

                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Pedidos
                    <span
                        class="badge badge-soft-success badge-pill float-end ms-1 font-size-12"
                    >854</span
                    ></a
                  >
                </li>

                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Clientes
                    <span
                        class="badge badge-soft-success badge-pill float-end ms-1 font-size-12"
                    >1.280</span
                    ></a
                  >
                </li>

                <li>
                  <a href="javascript:void(0);" class="text-muted py-2 d-block"
                  ><i class="mdi mdi-chevron-right me-1"></i> Usuários
                    <span
                        class="badge badge-soft-success badge-pill float-end ms-1 font-size-12"
                    >5</span
                    ></a
                  >
                </li>

              </ul>
            </div>
            <hr class="my-4" />

            <div>
              <p class="text-muted mb-2">Material de Apoio</p>

              <div class="list-group list-group-flush">
                <a href="javascript:void(0);" class="list-group-item text-muted py-3 px-2">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <img
                          src="@/assets/images/small/img-7.jpg"
                          alt=""
                          class="avatar-md h-auto d-block rounded"
                      />
                    </div>
                    <div class="flex-grow-1 overflow-hidden">
                      <h5 class="font-size-13 text-truncate">
                        Novo arquivo de fotos produto 00999
                      </h5>
                      <p class="mb-0 text-truncate">10 Abr, 2023</p>
                    </div>
                  </div>
                </a>

                <a href="javascript:void(0);" class="list-group-item text-muted py-3 px-2">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <img
                          src="@/assets/images/small/img-4.jpg"
                          alt=""
                          class="avatar-md h-auto d-block rounded"
                      />
                    </div>
                    <div class="flex-grow-1 overflow-hidden">
                      <h5 class="font-size-13 text-truncate">
                        Novo arquivo de fotos produto 88877
                      </h5>
                      <p class="mb-0 text-truncate">24 Mar, 2023</p>
                    </div>
                  </div>
                </a>

                <a href="javascript:void(0);" class="list-group-item text-muted py-3 px-2">
                  <div class="d-flex align-items-center">
                    <div class="me-3">
                      <img
                          src="@/assets/images/small/img-6.jpg"
                          alt=""
                          class="avatar-md h-auto d-block rounded"
                      />
                    </div>
                    <div class="flex-grow-1 overflow-hidden">
                      <h5 class="font-size-13 text-truncate">
                        Treinamento plataforma de vendas
                      </h5>
                      <p class="mb-0 text-truncate">11 Mar, 2023</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>

            <!--            <hr class="my-4" />-->

            <!--            <div>-->
            <!--              <p class="text-muted">Tags</p>-->

            <!--              <div class="d-flex flex-wrap gap-2 widget-tag">-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12">Design</a>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12"-->
            <!--                  >Development</a-->
            <!--                  >-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12">Business</a>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12">Project</a>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12">Travel</a>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12">Lifestyle</a>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <a href="javascript:void(0);" class="badge bg-light font-size-12"-->
            <!--                  >Photography</a-->
            <!--                  >-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->


          </div>
        </div>
        <!-- end card -->
      </div>







    </div>



  </Layout>
</template>
